export default {
  'deviceChallenge.header1':
    'An email with a key value has been sent to the email address on record.',
  'deviceChallenge.header2':
    'If you do not receive the Login Key email, please view your Spam folder ​​​​​​​or contact your Bank Administrator.',
  'deviceChallenge.enterKey': 'Enter Key',
  'deviceChallenge.rememberDevice': 'Remember this device',
  'deviceChallenge.sendKey': 'Send New Key',
  'deviceChallenge.keySent': 'New Key successfully sent.'
};
